import { useParams } from 'react-router-dom';
import EventWidget from '../components/widgets/EventWidget';

export default function EventWidgetPage() {
  const { restaurantId, eventId } = useParams();

  return (
    <div className="min-h-screen bg-gray-100 py-8 px-4">
      <EventWidget 
        eventId={eventId}
        restaurantId={restaurantId}
        config={{
          primaryColor: '#8B5CF6',
          theme: 'light'
        }}
      />
    </div>
  );
}
